import { intlLocale } from '~/i18n/locale';

/**
 * La fecha de inicio de una vacante: «15 may» en la fila, «15 de mayo» en la
 * hoja. Es una fecha de calendario (el DOL la guarda a medianoche UTC), así que
 * se lee en UTC: en Bogotá, la medianoche UTC del 15 es todavía el 14.
 */
export function formatStartDate(iso: string | null | undefined, month: 'short' | 'long'): string {
  if (!iso) return '';
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return '';
  return date.toLocaleDateString(intlLocale(), { day: 'numeric', month, timeZone: 'UTC' });
}

/**
 * El programa de la vacante, desde su `feed_type`. Siglas que no se traducen,
 * salvo Job Bank, que va con la frase de cada idioma. Sin programa conocido, nada.
 */
export function visaLabel(feedType: string | null | undefined, jobBank: string): string {
  switch (feedType) {
    case 'h2b':
      return 'H-2B';
    case 'h2a_jo':
    case 'dol_h2a':
      return 'H-2A';
    case 'jobbank':
      return jobBank;
    case 'eures_open':
    case 'eures_codc':
      return 'EURES';
    default:
      return '';
  }
}
